import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";
const { Item } = Form;

export const ConfigurationsContainer = styled.div`
  display: grid;
  grid-template-columns: 470px 120px 15px;
  align-items: center;
  grid-column-gap: 20px;
  margin-top: 20px;
  .icon {
    display: flex;
    height: 32px;
    border-radius: 300px;
    font-weight: ${(props) => props.theme["@medium-font-weight"]};
    font-size: ${(props) => props.theme["@small-font-size"]};
    align-content: center;
    align-items: center;
    width: fit-content;
  }
  .hoverActionButton {
    cursor: pointer;
  }
  .actionButton {
    float: right;
    margin-top: -5px;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const HeaderConfiguration = styled.div`
  display: flex;
  align-content: center;
  gap: 21px;
  justify-items: center;
  flex-direction: column;
`;

export const DescriptionConfiguration = styled.h1`
  align-content: center;
  font-weight: 600;
  font-size: 16px;
  margin: 0;
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfigurationDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: theme["@normal-font-weight"],
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: theme["@medium-font-size"],
};

export const FormItemFieldName = styled(Item)`
  .ant-input {
    margin-left: 0;
  }

  .ant-form-item-control {
    width: 100%;
  }

  .ant-input-number {
    width: 100%;
    min-width: 61px;
    max-width: 61px;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control-input-content {
    display: grid;
    margin-top: 7px;
  }

  .ant-input {
    box-shadow: none;
    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }
`;

export const ConfigurationsGroup = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
`;
